import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
  `,
  paper: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 358px;
    margin: 0px 16px;
    padding: 4px 16px 4px 0px;
    border-radius: 10px !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 4px 8px 3px rgba(0, 0, 0, 0.15);
  `,
  iconVariants: {
    success: css`
     color: ${colors.jungle} !important;
    `,
    info: css`
      color: ${colors.charcoal} !important;
    `,
    warning: css`
      color: ${colors.soil} !important;
    `,
    error: css`
      color: ${colors.dragon} !important;
    `,
  },
  variants: {
    success: css`
      border: 1px solid ${colors.jungle300} !important;
      background: ${colors.jungle200} !important;
    `,
    info: css`
      border: 1px solid ${colors.silver} !important;
      background: ${colors.platinum} !important;
    `,
    warning: css`
      color: ${colors.prussian};
      border: 1px solid ${colors.peach200} !important;
      background: ${colors.blonde} !important;
    `,
    error: css`
      border: 1px solid ${colors.dragon200} !important;
      background: ${colors.dragon100} !important;
    `,
  },
};

export default styles;
